import React, { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "../../components/Spinner/spinner";
import Cookies from "js-cookie";
import api from "../../api";
import Loading from "../../components/LoadingSpinner/loadingSpinner";

const Plancontent = ({ plan }) => {
  const [loading, setLoading] = useState(false);
  const [languageData, setLanguageData] = useState(null);
  useEffect(() => {
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      "en";

    if (cookieLang) {
      import(`../../lang/payments/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  const currencySymbolMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };

  const currencySymbol = currencySymbolMap[plan.currency] || plan.currency;
  const getURL = async () => {
    setLoading(true);
    try {
      const response = await api.post(`/invoicing/orders/create`, {
        source_id: plan.id,
        source_type:"package"
      });

      const paymentLink = response?.data?.data?.payment_link;

      if (paymentLink) {
        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          paymentLink,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );
        //   window.open(paymentLink, "_blank");
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const setURL = async (e) => {
    e.preventDefault();
    if (plan.external_type === "private_chat") {
    const dataUser = JSON.parse(
      localStorage.getItem(`${process.env.REACT_APP_USER_INFO}`)
    );

    const account_id = dataUser?.user_id;

    const chatUrl =
      `${process.env.REACT_APP_CHAT_URL}` +
      `?source=gocc&contact_account=${account_id}&action=pay`;
 const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          chatUrl,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );
    
    return;
  }
    await getURL();
  };
  const formatPrice = (price) => {
    return Number(price).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };
  if (!languageData) {
    return <div></div>;
  }

  return (
    /*  <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-12 pricing-card text-start">
      <div className="card custom-card overflow-hidden">
        <div className="card-body p-0">
          <div className="p-4 pricing-offer overflow-hidden">
          
            <h6 className="fw-semibold">{plan.name}</h6>

            <div className="pb-4 pt-2 d-flex">
              <div>
                <p className="mt-2 text-l fw-semibold mb-0">
                  <small>{currencySymbol}</small> {""}{" "}
                  {formatPrice(plan.price)}
                </p>
              </div>
            </div>
            <ul className="list-unstyled fs-12 pt-3 mb-0">
              {plan.items.map((service, index) => (
                <li key={index} className="mb-3">
                  <span className="text-muted">
                    {service.name}{" "}
                    <span className="badge bg-light text-default ms-1">
                      {languageData.plans.communication[service.communication]}
                    </span>
                  </span>
                  <p className="op-6 fw-normal text-black">
                    {service.description}
                  </p>
                </li>
              ))}
            </ul>
            <div className="d-grid">
              <button
                type="button"
                className={
                  plan.price
                    ? "btn btn-primary btn-wave waves-effect waves-light"
                    : "btn btn-primary-light btn-wave waves-effect waves-light"
                }
                onClick={setURL}
                disabled={loading}
              >
                {plan.price
                  ? languageData.plans.button2
                  : languageData.plans.button}
              </button>
            </div>
          </div>
        
        </div>
      </div>
    </div> */
    <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 col-sm-12 pricing-card text-start">
      <div className="package card custom-card overflow-hidden brilliant">
        <div className="card-body p-0 h-100">
          <div className="h-100 flex flex-column justify-content-between">
            <div className="name">{plan.name}</div>
            <div>
              <div className="trial">
                {" "}
                <small>{currencySymbol}</small> {""} {formatPrice(plan.price)}
              </div>
              <hr className="hr"
              ></hr>
            </div>

            <ul
              className="list-unstyled fs-12 pt-3 mb-0 text-left"
            >
              {plan.items.map((service, index) => (
                <li key={index} className="mb-3">
                  {service.communication === "call" ? (
                    <i
                      className="bi bi-telephone gray_color fs-12"
                    ></i>
                  ) : service.communication === "chat" ? (
                    <i class="bi bi-chat-left-text"></i>
                  ) : service.communication === "email" ? (
                    <i class="bi bi-envelope"></i>
                  ) : (
                    ""
                  )}
                  <span className="text-muted">
                    <span className="mr-5 font-700 text-default ms-1">
                      {" "}
                      {service.name}
                    </span>
                    {languageData.plans.communication[service.communication]}
                  </span>
                  <p className="op-6 fw-normal text-black">
                    {" "}
                    {service.description}
                  </p>
                </li>
              ))}
            </ul>
            <div className="d-grid">
              <button data-interaction="plan_button"
                type="button"
                className={
                  plan.price
                    ? "btn btn_buy btn-wave waves-effect waves-light"
                    : "btn btn-primary-light btn-wave waves-effect waves-light"
                }
                onClick={setURL}
                disabled={loading}
              >
                {plan.price
                  ? languageData.plans.button2
                  : languageData.plans.button}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PricingPlans = () => {
  const [plans, setPlans] = useState([]);

  const regularPlans = plans.filter((plan) => !plan.price);
  const discountedPlans = plans.filter((plan) => plan.price);
  const [languageData, setLanguageData] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/payments/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }

    const fetchPlans = async () => {
      try {
        setShowSpinner(true);
        const response = await api.get(`/invoicing/tariffs`);

        setPlans(response.data.data || response.data);
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setShowSpinner(false);
      }
    };

    fetchPlans();
  }, []);

  const privateChatPlans = plans.filter(
    (p) => p.external_type === "private_chat",
  );

  const regularAndOthersPlans = plans.filter(
    (p) => p.external_type !== "private_chat",
  );
  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div className="row m-0">
          <div className="col-xxl-11 col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="container-lg">
              <div className="row justify-content-center m-0">
                <div className="col-xl-9">
                  <h5 className="fw-semibold text-center">
                    {languageData.plans.title}
                  </h5>
                  <p className="text-muted text-center">
                    {languageData.plans.sub_title}
                  </p>
                </div>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane show active p-0 border-0 flex flex-column gap-30"
                  id="monthly-pane"
                  role="tabpanel"
                  aria-labelledby="monthly"
                  tabIndex="0"
                >
                  <div className="row m-0">
                    {regularAndOthersPlans.map((plan, index) => (
                      <Plancontent key={index} plan={plan} />
                    ))}
                  </div>
                  {privateChatPlans.length > 0 && (
                    <div className="col-12 mb-4">
                      <h5 className="fw-semibold text-center">
                        {languageData.private_packages.title}
                      </h5>
                      <p class="text-muted text-center">
                        {languageData.private_packages.description}
                      </p>
                      <div className="row m-0">
                        {privateChatPlans.map((plan, index) => (
                          <Plancontent key={index} plan={plan} />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PricingPlans;
